import { render } from "./Company.vue?vue&type=template&id=754e7c05&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

import "./Company.vue?vue&type=style&index=0&id=754e7c05&scoped=true&lang=css"
import "./Company.vue?vue&type=style&index=1&id=754e7c05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754e7c05"]])

export default __exports__